import React, { useEffect, useMemo, useState } from "react";
import { httpReauest } from "../../utils/httpRequest";

const Roadmap = ({ data }) => {
  const { balance, level } = data;

  const [thresholds, setThresholds] = useState({ 1: 0 }); // Map: { [level]: threshold }
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        setLoading(true);
        const res = await httpReauest("GET", "/admin/levels");
        const list =
          res?.data?.levelThresholds || res?.data?.data?.levelThresholds || [];
        // به Map تبدیل کنیم
        const map = {};
        for (const row of list) {
          if (row && typeof row.level === "number") {
            map[row.level] = Number(row.threshold) || 0;
          }
        }
        // حداقل سطح 1 با آستانه 0
        if (!map[1]) map[1] = 0;

        if (mounted) setThresholds(map);
      } catch (e) {
        // اگر ارور شد، همون پیش‌فرض خیلی ساده را نگه می‌داریم
        if (mounted) setThresholds({ 1: 0 });
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  // min همیشه آستانه‌ی سطح فعلی است (یا 0)
  const min = useMemo(() => thresholds[level] ?? 0, [thresholds, level]);

  // max آستانه‌ی سطح بعدی است؛ اگر نبود، خودش balance تا 100% نمایش دهد
  const max = useMemo(() => {
    const next = thresholds[level + 1];
    // اگر next تعریف شده باشد و از min بزرگ‌تر باشد، همان را برگردان
    if (typeof next === "number" && next > min) return next;
    // در غیر این صورت برای نمایش رینگ، max را برابر با balance می‌گیریم تا 100% شود
    return balance;
  }, [thresholds, level, balance, min]);

  const percentage = useMemo(() => {
    const denom = max - min;
    if (denom <= 0) return 100;
    // پیشرفت از آستانه‌ی سطح فعلی تا آستانه‌ی سطح بعدی
    return Math.min(Math.max(((balance - min) / denom) * 100, 0), 100);
  }, [balance, min, max]);

  const radius = 40;
  const circumference = 2 * Math.PI * radius;
  const dashOffset = circumference - (percentage / 100) * circumference;

  return (
    <div className="relative w-full max-w-2xl mx-auto">
      {/* Progress Circle */}
      <div className="absolute top-4 right-4 w-24 h-24">
        <svg width="100%" height="100%" viewBox="0 0 100 100">
          {/* Background circle */}
          <circle
            cx="50"
            cy="50"
            r="40"
            stroke="#e5e7eb"
            strokeWidth="8"
            fill="none"
          />

          {/* Yellow progress circle */}
          <circle
            cx="50"
            cy="50"
            r="40"
            stroke="#facc15"
            strokeWidth="8"
            fill="none"
            strokeDasharray={circumference}
            strokeDashoffset={dashOffset}
            strokeLinecap="round"
            transform="rotate(-90 50 50)"
            style={{ transition: "stroke-dashoffset 0.5s ease" }}
          />

          {/* Percentage text */}
          <text
            x="50"
            y="50"
            textAnchor="middle"
            dy=".3em"
            fontSize="14"
            fill="#fff"
          >
            {loading ? "..." : Math.round(percentage) + "%"}
          </text>
        </svg>
        <span className="block text-center text-[12px] whitespace-nowrap">
          {balance} / {max} FT
        </span>
      </div>

      {/* Roadmap Image */}
      <img
        src={`/roadmap/${Math.max(level - 1, 0)}.png`}
        className="w-full h-auto max-h-[540px] object-contain"
        alt="Road"
      />
    </div>
  );
};

export default Roadmap;
